const OTP_ROUTE_STATE_KEY = 'referral-agent-otp-route-state';
const OTP_ROUTE_STATE_TTL_MS = 10 * 60 * 1000;

export const saveOtpRouteState = (state) => {
	if (!state || typeof window === 'undefined') return;

	try {
		sessionStorage.setItem(
			OTP_ROUTE_STATE_KEY,
			JSON.stringify({
				...state,
				_savedAt: Date.now(),
			}),
		);
	} catch (error) {}
};

export const getOtpRouteState = () => {
	if (typeof window === 'undefined') return null;

	try {
		const storedState = sessionStorage.getItem(OTP_ROUTE_STATE_KEY);
		if (!storedState) return null;

		const parsedState = JSON.parse(storedState);
		if (Date.now() - Number(parsedState?._savedAt || 0) > OTP_ROUTE_STATE_TTL_MS) {
			sessionStorage.removeItem(OTP_ROUTE_STATE_KEY);
			return null;
		}

		const { _savedAt, ...routeState } = parsedState;
		return routeState;
	} catch (error) {
		sessionStorage.removeItem(OTP_ROUTE_STATE_KEY);
		return null;
	}
};

export const clearOtpRouteState = () => {
	if (typeof window === 'undefined') return;

	try {
		sessionStorage.removeItem(OTP_ROUTE_STATE_KEY);
	} catch (error) {}
};
